import React, { useEffect } from 'react';
// เปลี่ยนการ import เป็นแบบ Relative path ให้ตรงกับโครงสร้างโฟลเดอร์ React ปกติ
import FaceSwapPhotoBooth from '../components/PhotoApp/FaceSwapPhotoBooth';

export default function FaceSwapPage() {
    // ใช้ useEffect เพื่อตั้งชื่อ Title ของแท็บเบราว์เซอร์แทน next/head
    useEffect(() => {
        document.title = "AI Face Swap Booth | Smart Library";
    }, []);

    return (
        /* คลุมด้วย main เพื่อให้แน่ใจว่าใช้พื้นที่เต็มหน้าจอ 100vh */
        <main className="w-full h-screen bg-stone-950 overflow-hidden">
            <FaceSwapPhotoBooth />
        </main>
    );
}